/**
 * ReviewList
 * --
 */
import { useState, useEffect } from 'react';
import { Content, Title } from 'components';
import { Button, Table, Spin } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import MessageAlert, { strCut } from 'utils';
import moment from 'moment';
import { NoticeApi } from 'api';

/**----------------------------------------
 * [Component] 홈 > 매장별 매출 차트
 * ----------------------------------------
 */
const ReviewList = ({ data, isMobile }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== RENDER ===== */
  // console.log('[ReviewList]data: ', data);

  // JSX: start
  return (
    <>
      <Spin spinning={loading}>
        <Content
          maxWidth={'100%'}
          height={320}
          borderRadius={4}
          // padding={'14px 5px'}
        >
          <Title
            size={5}
            style={{ marginBottom: 12, fontSize: isMobile ? 14 : 16 }}
            subButton={
              <Button
                size="small"
                onClick={() => window.open('/review/list', '_blank')}
              >
                <ExportOutlined /> 리뷰관리
              </Button>
            }
          >
            승인 대기 리뷰
          </Title>
          <Table
            bordered
            size="small"
            scroll={{ x: 'max-content', y: 210 }}
            // style={{ height: 300 }}
            pagination={false}
            dataSource={data.slice(0, 5) ?? []}
            columns={[
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    등록일(시간)
                  </p>
                ),
                dataIndex: 'created_at',
                width: isMobile ? 100 : 200,
                align: 'center',
                render: (v) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {moment(v * 1000).format(
                      isMobile ? 'YY.MM.DD (HH:mm)' : 'YYYY-MM-DD (HH:mm:ss)',
                    )}
                  </p>
                ),
              },
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    내용
                  </p>
                ),
                dataIndex: 'review_content',
                // width: 220,
                align: 'center',
                render: (v) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {strCut(v, isMobile ? 30 : 100)}
                  </p>
                ),
              },

              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    상품
                  </p>
                ),
                dataIndex: 'product',
                width: isMobile ? 150 : 340,
                align: 'center',
                render: (product) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {strCut(product?.product_name, isMobile ? 15 : 30)}
                  </p>
                ),
              },
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    작성자
                  </p>
                ),
                dataIndex: 'user',
                width: isMobile ? 'auto' : 125,
                align: 'center',
                render: (user) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {user.user_name}
                  </p>
                ),
              },
            ]}
          />
        </Content>
      </Spin>
    </>
  ); // JSX: end
};

ReviewList.defaultProps = {
  onSelect: () => {},
};
export default ReviewList;
